// extracted by mini-css-extract-plugin
export default {"toolbar":"EducaFilesToolbar_toolbar__rl2gg","left":"EducaFilesToolbar_left__oHUgm","search":"EducaFilesToolbar_search__ld0al","select":"EducaFilesToolbar_select__TFbK-"};